/**
 * Returns `true` when the Hub space density (spacing) customization should be
 * available.
 *
 * Gated by advanced theming AND the `hub-space-density` Statsig gate
 * space density is always a sub-feature of advanced theming and never ships
 * without it.
 *
 * Cross-host safe: returns `false` when HubContext is not mounted (Confluence
 * Company Hub, CSM, etc.) because `useIsAdvancedThemingEnabled` returns false in
 * that case.
 */
import { fg } from '@atlaskit/platform-feature-flags';

import { useIsAdvancedThemingEnabled } from '../use-is-advanced-theming-enabled';

export const useIsHubSpaceDensityEnabled = (): boolean => {
	const isAdvancedThemingEnabled = useIsAdvancedThemingEnabled();
	return isAdvancedThemingEnabled && fg('hub-space-density');
};
